const getProduct = {
  get: (query = 'サンプル') => {
    return new Promise((resolve) => {
      fetch(`/search?view=get_products&type=product&q=${query}`, {
        'Method': 'POST',
        'Headers': {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(response => {
        resolve(response)
      })
      .catch(error => console.error(error))
    })
  }
}
const salesPeriod = {
  init: (start, end = dayjs('2999/12/31'), now = dayjs()) => {
    start = dayjs(start)
    end = dayjs(end)
    if(start.isBefore(now) && end.isAfter(now) || start.isBefore(now) && end.isSame(now)) {
      return true
    }
    return false
  }
}
const salesPeriodCheck = {
  submitEvt(elm) {
    elm.addEventListener('submit', async (e) => {
      e.preventDefault()
      const flg = await this.action(e)
      if(flg == true) {
        e.target.submit()
      }
    })
  },
  clickEvt(elm, submitBtn) {
    elm.addEventListener('click', async (e) => {
      e.preventDefault()
      const flg = await this.action(e)
      if(flg == true) {
        submitBtn.click()
      }
    })
  },
  async action (e){
    console.log(e.target)
    const query = `${e.target.dataset.productIds}`
    this.products = await getProduct.get(encodeURI(query))
    this.flg = true
    this.flg = this.periodCheck()
    if(this.flg === false) {
      alert('現在この商品は購入できません。')
      return false
    } else {
      return true
    }
  },
  periodCheck(){
    console.log(this.products)
    for(product of this.products) {
      if(product.product_metafields.preorder_from && product.product_metafields.preorder_to) {
        this.flg = salesPeriod.init(product.product_metafields.preorder_from, product.product_metafields.preorder_to)
      } else if(product.product_metafields.preorder_from) {
        this.flg = salesPeriod.init(product.product_metafields.preorder_from)
      } else {
        this.flg = true
      }
      if(this.flg === false) {
        return this.flg
      }
    }
    return this.flg
  }
}